import * as React from 'react';
import './index.css';
import { i18nClient, withTranslation } from '@sailor/i18n-mach-pro/lib';
import { HOME_PAGE_ERROR_CODE } from '@/src/pages/homepage/home_page_main/utils/constant';
import ListEmptyView from '@/components/ListEmptyView';
import { Dispatch, RootState } from '@/src/pages/homepage/home_page_main/models/store';
import { connect } from '@wmfe/mach-pro-store';
import { getDTCode } from '@/components/ListEmptyView/util';
import {
  SHOP_FAVORITES_MC_BID,
  SHOP_FAVORITES_MV_BID,
  PAGE_CODE,
  PreheatBtnMC,
  PreheatBtnMV
} from '@/src/pages/homepage/preheat/request/lx';

const WMRouter = Mach.requireModule('Router');

interface State {
}

const mapStateToProps = (state: RootState, dispatch: Dispatch) => ({
  // 获取Feed流数据请求方法
  fetchFeedListData: dispatch.global.fetchFeedListData,
  fetchAllPageData: dispatch.global.fetchAllPageData,
});

type IProps = ReturnType<typeof mapStateToProps>;

interface Props extends IProps {
  data: ErrorData;
  guideWord?;
}

interface ErrorData {
  code: number;
  imageUrl?: string;
  title?: string;
  message?: string;
  btnText?: string;
}

interface IState{
  code: number;
  imageUrl?: string;
  title?: string;
  message?: string;
  btnText?: string;
}

// 无供给
const noSupplyArea = HOME_PAGE_ERROR_CODE.NO_SUPPLY_AREA;
// 无数据
const noData = HOME_PAGE_ERROR_CODE.NO_DATA;

class CommonPage extends React.Component<Props, IState> {
  bgiHeight: number
  bgWidth: number

  constructor(props: Props) {
    super(props);
    this.bgWidth = Mach.env?.screenWidth || 375;
    this.bgiHeight = (412 / 375) * this.bgWidth;
    const data = this.props.data;
    this.setState({
      code: data.code,
      imageUrl: data.imageUrl,
      title: data.title,
      message: data.message,
      btnText: data.btnText
    });
    const guideWord = this.props.guideWord;
    if (guideWord?.buttonType === PAGE_CODE.SHOP_FAVORITES) {
      PreheatBtnMV(SHOP_FAVORITES_MV_BID);
    }
  }

  onClickButton = () => {
    const guideWord = this.props.guideWord;
    if (guideWord?.linkUrl) {
      WMRouter.navigateTo(guideWord?.linkUrl);
    } else {
      if (typeof this.props.fetchAllPageData === 'function') {
        this.props.fetchAllPageData();
      }
    }

    if (guideWord?.buttonType === PAGE_CODE.SHOP_FAVORITES) {
      PreheatBtnMC(SHOP_FAVORITES_MC_BID);
    }
  }

  renderItem = () => {
    const {
      code, btnText, imageUrl, message
    } = this.props.data;
    const showButton = code === noSupplyArea || code === noData;
    let buttonText = btnText;
    if (showButton) {
      buttonText = '';
    }
    let dtCode = '';
    if (isShowDtCode(code)) {
      dtCode = getDTCode(code);
    }
    return (
      <view className="container">
        <view className="page-container">
          <ListEmptyView
            icon={imageUrl}
            title={message}
            retryBtnTitle={buttonText}
            onClickRetryBtn={this.onClickButton}
            dtCode={dtCode}
          />
        </view>
      </view>
    );
  }

  render() {
    return this.renderItem();
  }
}

function isShowDtCode(code: number) {
  if (code === undefined) {
    return false;
  }
  let result = true;
  switch (code) {
    case HOME_PAGE_ERROR_CODE.PRE_PAGE_LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.PRE_PAGE_NO_LOGIN_COE:
    case HOME_PAGE_ERROR_CODE.LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.NO_SUPPLY_AREA:
    case HOME_PAGE_ERROR_CODE.NO_DATA:
    case HOME_PAGE_ERROR_CODE.NO_SERVICE:
    case HOME_PAGE_ERROR_CODE.LOADING:
    case HOME_PAGE_ERROR_CODE.OTHER_EMPTY_PAGE:
      result = false;
      break;
    default:
      break;
  }
  return result;
}

export default connect(mapStateToProps)(withTranslation('', {
  withRef: true
})(CommonPage));
